"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Card_1 = __importDefault(require("@material-ui/core/Card"));
const CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const core_1 = require("@material-ui/core");
function Panel(props) {
    return (react_1.default.createElement(Card_1.default, { style: { margin: 10 }, className: props.className },
        react_1.default.createElement(core_1.CardHeader, { title: props.title }),
        react_1.default.createElement(CardContent_1.default, null,
            props.children,
            react_1.default.createElement(Typography_1.default, { color: "textSecondary", gutterBottom: true }))));
}
exports.default = Panel;
//# sourceMappingURL=Panel.js.map